export const InfoText = {
    PUBLISH_WAS_SUCCESSFUL: "Your changes were published successfully",
    PUBLISH_WAS_NOT_SUCCESSFUL: "Sorry there was an error. You Changes were no published.",
    RESERVE_FEED_POINT_ERROR: "Man kan endast aktivera/deaktivera en reservmatarpunkt när minst en normal matarpunkt är antigen deaktiverad/aktiverad.",
    LAST_REGULAR_FEED_POINT_ERROR: "Kan inte aktivera matarpunkten utan att först deaktivera reservmatarpunkten.",
    DEACTIVATE_RESERVE_FEED_POINT_ERROR: "Det är endast möjligt att aktivera en reguljär matarpunkt när reservmatarpunkten inte är aktiv."
}